<div class="month-range-container">
  <div class="date-header">{{headerName}}</div>
    <div class="year-selection">
      <div class="year-panel">
        <app-material-calendar
          [minYear]="minYear"
          [maxYear]="maxYear"
          [selectedYear]="startYear"
          [disabledYears]="disabledYearsForStartSelector"
          (yearSelected)="onStartYearSelected($event)"
        ></app-material-calendar>
      </div>
    </div>
  
    <div class="month-range-calendar">
      <div class="month-range-panel">
        <div class="month-range-grid">
          <div class="month-range" *ngFor="let month of months">
              <button class="month-range-button"
                [class.selected]="isSelected(month)"
                [class.monthdisabled]="isDisabled(month)"
                (click)="selectMonth(month)">
                {{ month.split(' ')[0] }}
              </button>
          </div>
        </div>
      </div>
    </div>
  
    <div class="date-inputs">
      <div class="input-group">
        <span class="input-group-text" style="padding: 6px 9px;">Start Date</span>
        <input type="text" class="form-control" [value]="selectedStartMonth |date:'MM.dd.yyyy'" readonly />
      </div>
      <div class="input-group">
        <span class="input-group-text">End Date</span>
        <input type="text" class="form-control" [value]="selectedEndMonth |date:'MM.dd.yyyy'" readonly />
      </div>
    </div>
  
    <div class="actions">
      <button matTooltip="Clear Selection" class="btn clear" (click)="clearDates()">Clear</button>
      <button matTooltip="Apply Selection"  class="btn apply" cdkMenu  [disabled]="!selectedStartMonth || !selectedEndMonth" (click)="applyDates()">Apply</button>
    </div>
  </div>
  